var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.126,
    height: 15.126,
    viewBox: "0 0 15.126 15.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(-203 -281.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_FILL0_wght400_GRAD0_opsz48",
    d: "M20.2,21.076l-5.525-5.525a4.629,4.629,0,0,1-1.471.851,5.2,5.2,0,0,1-1.786.3,5.231,5.231,0,0,1-3.845-1.576A5.182,5.182,0,0,1,6,11.328a5.182,5.182,0,0,1,1.576-3.8A5.206,5.206,0,0,1,11.4,5.95a5.147,5.147,0,0,1,3.792,1.576,5.377,5.377,0,0,1,1.271,5.546,5.332,5.332,0,0,1-.882,1.576l5.546,5.5Zm-8.8-5.63a3.932,3.932,0,0,0,2.9-1.208,3.984,3.984,0,0,0,1.2-2.91,3.984,3.984,0,0,0-1.2-2.91A3.932,3.932,0,0,0,11.4,7.21,4.124,4.124,0,0,0,7.26,11.328,4.124,4.124,0,0,0,11.4,15.446Z",
    transform: "translate(197 275.698)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0f32c353b4ad2c0574767f4719acd920.svg";
export { ForwardRef as ReactComponent };